<div class="confirmar">
  <h1 class="confirmar__title">Aviso de cierre de sesión</h1>
  <p class="confirmar__description">Tu sesión está a punto de expirar, ¿necesitas más tiempo?</p>
  <div class="confirmar__buttons">
    <ion-button
      expand="full"
      class="eliminar"
      shape="round"
      (click)="ok()"
      (keypress)="true">
      <span>MANTENER SESIÓN ACTIVA</span>
    </ion-button>
    <ion-button
      expand="full"
      class="cancelar"
      shape="round"
      (click)="cancel()"
      (keypress)="true">
      <span>CERRAR SESIÓN</span>
    </ion-button>
  </div>
</div>
